import { render, staticRenderFns } from "./ExtendOtherNutrientsVitaminK.vue?vue&type=template&id=610f91e2&scoped=true"
import script from "./ExtendOtherNutrientsVitaminK.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsVitaminK.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsVitaminK.vue?vue&type=style&index=0&id=610f91e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f91e2",
  null
  
)

export default component.exports